const catalogsLang = {
  en: {
    catalogs: "Catalogs",
    expenseTypes: "Expense types",
    tasks: "Tasks",
    tematicAxis: "Admission reason",
    divisionTematicAxis: "Admission reason division",
    familyBond: "Family bond",
    relatedBond: "Related bond",
    theme_insert_succesful: "The theme has been saved correctly",
    // AGE GROUP
    age_group_updated_successful: "The age group has been updated correctly",
    // ACADEMIC
    academic_degree_insert_succesful:
      "The academic degree has been saved correctly",
    academic_degree_deleted_successful:
      "The academic degree has been deleted correctly",
    // REFERRING
    referring_insert_succesful: "The referring has been saved correctly",
    referring_updated_successful: "The referring has been updated correctly",
    referring_deleted_successful: "The referring has been deleted correctly",
    referring_list_retrieved: "Referring list retrieved successfully",
    referring_retrieved_successful: "Referring retrieved successfully",
    referring_not_found: "Referring not found",
    referring_insert_error: "Error saving referring",
    referring_update_error: "Error updating referring",
    // LINGUISTIC COMMUNITY
    linguistic_community_insert_succesful: "The linguistic community has been saved correctly",
    linguistic_community_updated_successful: "The linguistic community has been updated correctly",
    linguistic_community_deleted_successful: "The linguistic community has been deleted correctly",
    linguistic_community_list_retrieved: "Linguistic community list retrieved successfully",
    linguistic_community_retrieved_successful: "Linguistic community retrieved successfully",
    linguistic_community_not_found: "Linguistic community not found",
    linguistic_community_insert_error: "Error saving linguistic community",
    linguistic_community_update_error: "Error updating linguistic community",
    // FAMILY BOND
    family_bond_insert_succesful: "The family bond has been saved correctly",
    family_bond_updated_successful: "The family bond has been updated correctly",
    family_bond_deleted_successful: "The family bond has been deleted correctly",
    family_bond_list_retrieved: "Family bond list retrieved successfully",
    family_bond_retrieved_successful: "Family bond retrieved successfully",
    family_bond_not_found: "Family bond not found",
    family_bond_insert_error: "Error saving family bond",
    family_bond_update_error: "Error updating family bond",
  },
  es: {
    catalogs: "Catálogos",
    expenseTypes: "Tipos de gasto",
    tasks: "Tareas",
    tematicAxis: "Motivo de ingreso",
    divisionTematicAxis: "División motivo de ingreso",
    familyBond: "Vínculo familiar",
    relatedBond: "Vínculo relacionado",
    theme_insert_succesful: "El taller se ha guardado correctamente",
    // AGE GROUP
    age_group_updated_successful:
      "El grupo etario ha sido actualizado correctamente",
    // ACADEMIC
    academic_degree_insert_succesful:
      "El grado académico se ha guardado correctamente",
    academic_degree_deleted_successful:
      "El grado académico se ha eliminado correctamente",
    // REFERRING
    referring_insert_succesful: "El referente se ha guardado correctamente",
    referring_updated_successful: "El referente ha sido actualizado correctamente",
    referring_deleted_successful: "El referente se ha eliminado correctamente",
    referring_list_retrieved: "Lista de referentes obtenida correctamente",
    referring_retrieved_successful: "Referente obtenido correctamente",
    referring_not_found: "Referente no encontrado",
    referring_insert_error: "Error al guardar el referente",
    referring_update_error: "Error al actualizar el referente",
    // LINGUISTIC COMMUNITY
    linguistic_community_insert_succesful: "La comunidad lingüística se ha guardado correctamente",
    linguistic_community_updated_successful: "La comunidad lingüística ha sido actualizada correctamente",
    linguistic_community_deleted_successful: "La comunidad lingüística se ha eliminado correctamente",
    linguistic_community_list_retrieved: "Lista de comunidades lingüísticas obtenida correctamente",
    linguistic_community_retrieved_successful: "Comunidad lingüística obtenida correctamente",
    linguistic_community_not_found: "Comunidad lingüística no encontrada",
    linguistic_community_insert_error: "Error al guardar la comunidad lingüística",
    linguistic_community_update_error: "Error al actualizar la comunidad lingüística",
    // FAMILY BOND
    family_bond_insert_succesful: "El vínculo familiar se ha guardado correctamente",
    family_bond_updated_successful: "El vínculo familiar ha sido actualizado correctamente",
    family_bond_deleted_successful: "El vínculo familiar se ha eliminado correctamente",
    family_bond_list_retrieved: "Lista de vínculos familiares obtenida correctamente",
    family_bond_retrieved_successful: "Vínculo familiar obtenido correctamente",
    family_bond_not_found: "Vínculo familiar no encontrado",
    family_bond_insert_error: "Error al guardar el vínculo familiar",
    family_bond_update_error: "Error al actualizar el vínculo familiar",
  },
};

export default catalogsLang;
